export const uk = {
    'campaign-group': 'Кампания/группа',
    'campaign-type': 'Тип кампании',
    name: 'Название',
    'price-context': 'Ставка за тыс. показов,{currency}',
    'price-context-networks': 'Ставка (в сетях), {currency}',
    'user-profile-condition': 'Условия показа'
};
